__turbopack_context__.v({
  "countdown-timer": "WhatsNewMenu-module-scss-module__aYWjzq__countdown-timer",
  "cta": "WhatsNewMenu-module-scss-module__aYWjzq__cta",
  "is-open": "WhatsNewMenu-module-scss-module__aYWjzq__is-open",
  "pill": "WhatsNewMenu-module-scss-module__aYWjzq__pill",
  "popover-wrapper": "WhatsNewMenu-module-scss-module__aYWjzq__popover-wrapper",
  "trigger": "WhatsNewMenu-module-scss-module__aYWjzq__trigger",
  "trigger-icon": "WhatsNewMenu-module-scss-module__aYWjzq__trigger-icon",
  "trigger-label": "WhatsNewMenu-module-scss-module__aYWjzq__trigger-label",
});
